module.exports = __webpack_public_path__ + "static/img/img4.07a36e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img4.jpg
// module id = 2xO4
// module chunks = 1